import React from "react";
import "../Styles/KgreatProjectPic.css";
import DejDeluxe from "../Components/Assets/Dej-Deluxe/DEJ1.jpg";
import DejDeluxe1 from "../Components/Assets/Dej-Deluxe/DEJ1.jpg";
import DejDeluxe2 from "../Components/Assets/Dej-Deluxe/DEJ2.jpg";
import DejDeluxe3 from "../Components/Assets/Dej-Deluxe/DEJ3.jpg";
import DejDeluxe4 from "../Components/Assets/Dej-Deluxe/DEJ4.jpg";
import DejDeluxe5 from "../Components/Assets/Dej-Deluxe/DEJ5.jpg";
import DejDeluxe6 from "../Components/Assets/Dej-Deluxe/DEJ6.jpg";
import DejDeluxe7 from "../Components/Assets/Dej-Deluxe/DEJ7.jpg";


const ProjPicDejDeluxe = () => {
  return (
    <>
      <section className="sectionProjectPic">
        <div className="divProjPicLanding">
          <div className="divProjectsImage">
            <img
              alt="ProjectPicture"
              src={DejDeluxe}
              className="projectsLandingImage"
            />
          </div>
          <div className="divImageText">
            <h1 className="headingImage">DEJ-DELUXE</h1>
            <h1 className="headingImage1">VICTORIA ISLAND, LAGOS</h1>
            <p className="textOfImage">CONSULTING</p>
          </div>
        </div>

        {/* <div className="divProjPictTextOf">
          <p className="aboutProject">
            <span>PROJECT:</span> : PROPOSED RESIDENTIAL DEVELOPMENT FOR
            LEVITIKAL GROUP AT OKO-AWO STREET, VICTORIA ISLAND, LAGOS.
          </p>
          <p className="aboutProject">
            <span>BUILDING TYPE:</span>
            MIXED TYPED RESIDENTIAL AND OFFICE BUILDING ON 23 FLOORS.
          </p>
          <p className="aboutProject">
            <span>STATUS: </span>
            ONGOING
          </p>
          <p className="aboutProject">
            We were engaged to provide MEP consultancy & Installation services
            for a mixed typed residential and office building on 23 floors. The
            architectural design was carefully studied and state of the art and
            modern applications in the MEP industry was utilized for the design
            of the building. <br />
            The plumbing services recommended for the building utlizes the top
            range obatainable in the industry, Electrical system put into
            consideration energy saving options for lighting and power
            generation, and the Air conditioning was carefully thought out and
            design to meet industry energy efficiency standards.
          </p>
        </div> */}

        <div className="divProjPicMain">
          <div className="divProjectImagesOf">
            <img alt="HeroImg" src={DejDeluxe1} className="projPicImageOf" />
          </div>
          <div className="divProjectImagesOf">
            <img alt="HeroImg" src={DejDeluxe2} className="projPicImageOf" />
          </div>
          <div className="divProjectImagesOf">
            <img alt="HeroImg" src={DejDeluxe3} className="projPicImageOf" />
          </div>
          <div className="divProjectImagesOf">
            <img alt="HeroImg" src={DejDeluxe4} className="projPicImageOf" />
          </div>
          <div className="divProjectImagesOf">
            <img alt="HeroImg" src={DejDeluxe5} className="projPicImageOf" />
          </div>
          <div className="divProjectImagesOf">
            <img alt="HeroImg" src={DejDeluxe6} className="projPicImageOf" />
          </div>
          <div className="divProjectImagesOf">
            <img alt="HeroImg" src={DejDeluxe7} className="projPicImageOf" />
          </div>
        </div>
      </section>
    </>
  );
};

export default ProjPicDejDeluxe;
